import { AuthenticationService } from "@app/shared/services/authentication.service";

export class AccessToken {
 
  getToken() {
    let token = null;
    let userData = null;
    userData = JSON.parse(window.localStorage.getItem('userDetails'));
    if (userData) {
      token = userData.accessToken;
    }
    else {
      userData = JSON.parse(window.sessionStorage.getItem('userDetails'));
      token = userData != null ? userData.accessToken : null;
    }
    return token;
  }
  getLoggedUserId() {
    let userId = null;
    let userData = null;
    userData = JSON.parse(window.localStorage.getItem('userDetails'));
    if (userData) {
      userId = userData.id;
    }
    else {
      userData = JSON.parse(window.sessionStorage.getItem('userDetails'));
      userId = userData != null ? userData.id : null;
    }
    return userId;
  }
}




// WEBPACK FOOTER //
// ./src/app/util/accessToken.ts